export enum ApiEditSensorKnownErrorsEnum {
  SENSOR_UNIQUE_PRODUCT_KEY_ALREADY_USED = 'SENSOR_UNIQUE_PRODUCT_KEY_ALREADY_USED',
  SENSOR_ALREADY_USED = 'SENSOR_ALREADY_USED',
}
